import FilterBase from "./FilterBase";

class PagedFilterBase extends FilterBase {
  public Page = 1;
  public PageSize = 20;
}

export default PagedFilterBase